import React from 'react';
import Icon from '../../../components/AppIcon';

const ChatMessage = ({ message }) => {
  const { role, content, timestamp, isError } = message;
  const isUser = role === 'user';

  return (
    <div className={`flex gap-3 ${isUser ? 'flex-row-reverse' : 'flex-row'}`}>
      <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
        isUser ? 'bg-primary text-primary-foreground' : 'bg-accent text-accent-foreground'
      }`}>
        <Icon name={isUser ? 'User' : 'Bot'} size={20} />
      </div>
      
      <div className={`flex-1 max-w-[80%] ${
        isUser ? 'flex justify-end' : 'flex justify-start'
      }`}>
        <div className={`rounded-lg p-4 ${
          isUser 
            ? 'bg-primary text-primary-foreground' 
            : isError
            ? 'bg-error/10 text-error border border-error/20' :'bg-muted text-foreground'
        }`}>
          <p className="whitespace-pre-wrap leading-relaxed">{content}</p>
          {timestamp && (
            <p className={`text-xs mt-2 ${
              isUser ? 'text-primary-foreground/70' : 'text-muted-foreground'
            }`}>
              {timestamp?.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
